export default {
  loading: 'Se încarcă prețurile…',
  default_modal: {
    title: 'Listă de prețuri implicite',
    description:
      'Prețurile de rezervă pe care le moștenește fiecare partener fără o suprascriere proprie. Modificările nu afectează niciodată licențele active.',
    saved: 'Listă de prețuri implicite salvată.',
  },
  buttons: {
    edit: 'Editează',
    cancel: 'Anulează',
    save: 'Salvează',
  },
  toasts: {
    load_error: 'Datele de prețuri nu au putut fi încărcate.',
    save_error: 'Nu s-a putut salva — vă rugăm încercați din nou.',
    prices_saved: 'Listă de prețuri salvată.',
    license_created: 'Licență creată.',
    lifecycle: {
      pause: 'Licență suspendată.',
      resume: 'Licență reluată.',
      cancel: 'Licență anulată.',
    },
  },
  price_book: {
    title: 'Listă de prețuri',
    read_only_notice:
      'Prețurile partenerului suprascriu lista implicită principală. Licențele active își păstrează prețurile blocate.',
    editing_notice: 'Editare — noile prețuri se aplică doar licențelor create de acum înainte.',
    columns: {
      service: 'Serviciu',
      cost_price: 'Preț brut ({{currency}}/lună, incl. TVA)',
    },
    add_ons: 'Suplimente',
    missing_price: '{{name}} este activat dar nu are preț — setați unul sau dezactivați-l.',
    incomplete_tier:
      '{{name}} are nevoie atât de un preț de volum, cât și de numărul de locații active de la care se aplică, sau de niciunul dintre ele.',
    invalid_tier: 'Prețul de volum al {{name}} trebuie să fie sub prețul standard, de la cel puțin 2 locații active.',
    tier: {
      from: 'Preț de volum de la',
      live_locations: 'locații active',
      counted_one: 'Acest partener are {{count}} locație licențiată activă luată în calcul pentru prețul de volum.',
      counted_few: 'Acest partener are {{count}} locații licențiate active luate în calcul pentru prețul de volum.',
      counted_other: 'Acest partener are {{count}} locații licențiate active care contează pentru prețul de volum.',
    },
    snapshot_note: 'Prețurile sunt blocate pe licență la creare — editarea listei nu modifică licențele active.',
    types: {
      base: 'De bază',
      add_on: 'Supliment',
    },
  },
  volume_discount: {
    title: 'Reducere de volum',
    read_only_notice:
      'Odată ce o factură lunară atinge pragul de licențe, reducerea se aplică tuturor taxelor de licență din acel ciclu.',
    editing_notice: 'Editare — noile setări se aplică începând cu următorul ciclu de facturare.',
    threshold_label: 'Prag licențe',
    percent_label: 'Reducere',
    invalid: 'Introduceți un prag de cel puțin 1 și o reducere între 0 și 100%.',
    saved: 'Reducere de volum salvată.',
    note: 'Se numără licențele facturate chiar în ciclul curent; lunile reportate sunt excluse. 0% (implicit) dezactivează reducerea — altfel s-ar cumula peste prețul de volum din lista de prețuri.',
  },
  licenses: {
    test_restaurant_unlicensable: 'Un restaurant de test nu este facturat niciodată, deci nu poate deține o licență.',
    title: 'Licențe restaurant',
    select_company: 'Selectați un restaurant',
    add_license: 'Adaugă licență',
    no_companies: 'Acest partener nu are restaurante încă.',
    no_licenses: 'Nicio licență pentru acest restaurant încă.',
    activated_at: 'Activ din',
    next_period_preview: 'Luna viitoare (prorată, înainte de reducerea de volum)',
    statuses: {
      active: 'Activ',
      paused: 'Suspendat',
      canceled: 'Anulat',
    },
    columns: {
      product: 'Serviciu',
      locked_price: 'Preț blocat / lună',
      quantity: 'Cant.',
      trial_ends: 'Gratuit până',
    },
    price_tiers: {
      volume: 'Tarif de volum',
      locked: 'Preț vechi',
    },
  },
  lifecycle: {
    pause: {
      action: 'Suspendă',
      title: 'Suspendați această licență?',
      description:
        'Zilele suspendate nu sunt facturate. Licența își păstrează prețurile blocate și poate fi reactivată oricând.',
      confirm: 'Suspendă',
    },
    resume: {
      action: 'Reactivează',
      title: 'Reactivați această licență?',
      description: 'Facturarea continuă de azi la prețurile blocate.',
      confirm: 'Reactivează',
    },
    cancel: {
      action: 'Anulează licența',
      title: 'Anulați această licență?',
      description:
        'Luna curentă este facturată pro-rata până astăzi. Aceasta nu poate fi anulată — o licență nouă ar fi creată la prețurile curente din listă.',
      confirm: 'Anulează licența',
    },
  },
  add_license: {
    title: 'Adaugă o licență',
    description: 'Selectați serviciile pentru acest restaurant. Prețurile sunt blocate pe licență la creare.',
    per_month: ' / lună',
    create: 'Creează licență',
    no_priced_products:
      'Niciun produs nu are încă un preț utilizabil pentru acest partener — setați mai întâi lista de prețuri.',
  },
};
